import { endpoints } from 'api/endpoints'
import { GetArrayResponse, GetOneResponse } from 'interfaces/api.interfaces'
import { RtmParameters, RtmParametersBase } from 'interfaces/api/rtmParameters.interfaces'
import { axios } from 'modules/axios'

const getAll = async (): GetArrayResponse<RtmParameters> => {
  const { data: response } = await axios.request<RtmParameters[]>({
    method: 'GET',
    url: endpoints.rtmParameters.getAll(),
  })
  return response
}

const create = async (data: RtmParametersBase): GetOneResponse<RtmParameters> => {
  const { data: response } = await axios.request<RtmParameters>({
    method: 'POST',
    url: endpoints.rtmParameters.create(),
    data,
  })
  return response
}

const update = async (id: number, data: RtmParametersBase): GetOneResponse<RtmParameters> => {
  const { data: response } = await axios.request<RtmParameters>({
    method: 'PATCH',
    url: endpoints.rtmParameters.update(id),
    data,
  })
  return response
}

const remove = (id: number): Promise<void> =>
  axios.request({
    method: 'DELETE',
    url: endpoints.rtmParameters.remove(id),
  })

export const rtmParametersApi = {
  create,
  getAll,
  update,
  remove,
}
